// extracted by mini-css-extract-plugin
export default {"ticketItem":"CollectIssueFee_ticketItem__yTDeB","textInfor":"CollectIssueFee_textInfor__hgbsA","inforWithIcon":"CollectIssueFee_inforWithIcon__DvVb3"};